// extracted by mini-css-extract-plugin
export default {"alert":"StatusMessage_alert__a6x2h","success":"StatusMessage_success__pBW+H","error":"StatusMessage_error__7331Z","info":"StatusMessage_info__7LxFR"};